import { DiscussionEmbed } from "disqus-react";

export default function DiscussionEmbedApplication() {
    return (
        <DiscussionEmbed
            shortname="planaday-budget-calculator"
            config={{
                url: `${process.env.REACT_APP_PLANADAY_BASE_URL}`,
                identifier: "PlanadayBudgetCalculator",
                title: "Planaday Budget Calculator",
                language: "en_UK",
            }}
        />
    );
}
